import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface PaymentRequest {
    payment_date: string;
    payment_method?: string;
    payment_amount: number;
    payment_memo?: string;
    start_date?: string;
    end_date?: string;
}

interface PaymentResponse {
    payment_history_idx: number;
    current_amount: number;
    pending_amount: number;
}

export const usePostPaymentOtherBranch = (customerIdx: number, orderIdx?: number, successCallback?: (data: PaymentResponse) => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (paymentData: PaymentRequest) => {
            const url = `${enum_api_uri.post_settlements.replace(":customer_idx", customerIdx.toString())}${
                orderIdx !== undefined ? `?order_idx=${orderIdx}` : ""
            }`;
            const response = await axios.post(url, paymentData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data as PaymentResponse;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["getOBPaymentHistory"] });
            queryClient.invalidateQueries({ queryKey: ["getOtherBranchCustomerList"] });
            queryClient.invalidateQueries({ queryKey: ["getOtherBranchInfo"] });
            queryClient.invalidateQueries({ queryKey: ["getOtherBranchList"] });
            queryClient.invalidateQueries({ queryKey: ["getOtherBranchCustomerCount"] });

            successCallback?.(data);
        },
    });
};
